import { Grid } from "@mui/material";
import LabelValueDisplay from "../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay";
import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { GET_DP_INFO, GET_TRANSFER_LICENSE, GET_WH_ProdGP_DEVICE_LIST } from "../../actions/types";
import { getInventoryWarehouseTableData, getTransferLicenseData, getWHProdGPDeviceListData, getCancelDeRegisterData  } from "../../actions/Users/authenticateInventory";
import _ from "lodash";
import CustomLoader from "../Loader/CustomLoader";
import change_license_icon from '../../asset/image/change_license_icon.svg';
import AddButton from "../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton";
import AddEditInterfaceModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/AddEditInterfaceModal";
import OptionSelector from "../../UserScreen/InventoryPage/InventorySettings/UserScreens/TransferTab/OptionSelector";
import { getOrganisationInfo } from "../../actions/Users/authenticate";
import moment from "moment";
import SingleLineDisplay from '../../UserScreen/InventoryPage/InventorySettings/components/SingleLineDisplay';
import InfoModal from '../../UserScreen/InventoryPage/InventorySettings/components/Modals/InfoModal';
import { formatToReadable } from '../../utils/util';

const Association = (props) => {
    const { row, setOpen, getWHProdGPDeviceListData, getWHProdGPDeviceList, setWHProdGPDeviceListLoading, getTransferLicenseData, getTransferLicense, setTransferLicenseLoading, getOrganisationInfo, getDpInfo, setDpInfoLoading, getInventoryWarehouseTableData, selectedOu, trackInventoryStatusData, getCancelDeRegisterData } = props;

    const [devicesList, setDevicesList] = useState<any>([]);
    const dispatch = useDispatch();
    const [selectedDevice, setSelectedDevice] = useState<string>('');
    const [dialogueMessage, setDialogueMessage] = useState<string>('');
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState<string>();
    const [radioValue, setRadioValue] = useState<string>('');
    const [isAllowed, setIsAllowed] = useState<any>({});
    const [syncInprogress, setSyncInprogress] = useState(false);
    const [cancelDeRegReason, setCancelDeRegReason] = useState('');
    const [reasonError, setReasonError] = useState("");
    const [warningModal, setWarningModal] = useState(false);

    useEffect(() => {
        getWHProdGPDeviceListData(row?.['k4DpId'], row?.['deviceId']);
        getOrganisationInfo(row?.dpName);
    }, []);

    useEffect(() => {
        if (!_.isEmpty(getDpInfo) && getDpInfo.hasOwnProperty('status') && getDpInfo.status == 1) {
            const dpInfo = getDpInfo?.data;
            setIsAllowed({ isPauseAllowed: dpInfo?.IsPauseAllowed, isTransferAllowed: dpInfo?.isTransferAllowed });
            dispatch({ type: GET_DP_INFO, payload: {} })
        }
    }, [getDpInfo])

    useEffect(() => {
        if (!_.isEmpty(getWHProdGPDeviceList)) {
            const res = getWHProdGPDeviceList.hasOwnProperty('data') ? getWHProdGPDeviceList?.data : [];
            setDevicesList(res);
            dispatch({ type: GET_WH_ProdGP_DEVICE_LIST, payload: {} })
        }
    }, [getWHProdGPDeviceList]);

    useEffect(() => {
        if (!_.isEmpty(getTransferLicense)) {
            const res = getTransferLicense;
            if (res?.message && (res?.error_code == 12016 || res?.error_code == 12022)) {
                setDialogueMessage(res.message);
            } else {
                setOpen(false);
                handleResetValues();
            }
            dispatch({ type: GET_TRANSFER_LICENSE, payload: {} })
            getInventoryWarehouseTableData(selectedOu?.id , '', 1, 15, 'shipmentDate', 'desc');
        }
    }, [getTransferLicense]);

    const handleConfirm = () => {
        switch (radioValue) {
            case 'transfer_license':
                getTransferLicenseData(row?.['deviceId'], selectedDevice?.split(' (')?.[0], dialogueMessage ? true : false);
                break;
            case 'cancel-de-reg':
                getCancelDeRegisterData(row?.['deviceId'], cancelDeRegReason);
                handleResetValues();
                break;
            default:
                break;
        }
    }

    const getRadioOptions = (type) => {
        if (type == "change") {
            return [
                isAllowed?.isTransferAllowed && row?.['licenseType'] == 'Production' && row?.expiryDate && moment(row?.expiryDate).startOf("day").isSameOrAfter(moment().startOf("day")) && { value: "transfer_license", label: "Transfer License" },
            ].filter(Boolean) as { value: string; label: string }[];
        }
        else if(type == 'cancel-de-reg') {
            return [
                { value: "cancel-de-reg", label: "Cancel DeRegistration" }
            ];
        }
        return [];
    };

    const handleRadioChange = (e) => {
        setRadioValue(e.target.value);
    };

    const radioGroup = {
        columns: [
            {
                component: (
                    <OptionSelector
                        value={radioValue}
                        onChange={handleRadioChange}
                        options={getRadioOptions(selectedOption)}
                    />
                ),
                gridSize: 12,
            },
        ],
    };

    useEffect(() => {
        const options = getRadioOptions(selectedOption);
        if (options.length > 0) {
            setRadioValue(options[0].value);
        }
    }, [selectedOption]);

    const getLayout = () => {
        const layout: any[] = [radioGroup];
        if (radioValue == "transfer_license") {
            layout.push(
                {
                    columns: [
                        {
                            component: (
                                <LabelValueDisplay
                                    label="From Device"
                                    value={row['deviceId']}
                                />
                            ),
                            gridSize: 12,
                        },
                    ],
                },
                {
                    columns: [
                        {
                            component: (
                                <LabelValueDisplay
                                    label="To Device"
                                    isDropdown={true}
                                    dropdownOptions={devicesList?.map((device) => device?.deviceId)}
                                    value={selectedDevice}
                                    onChange={(e) => {setSelectedDevice(e.target.value); setDialogueMessage('')}}
                                    placeholder='Select Device'
                                />
                            ),
                            gridSize: 12,
                        },
                    ],
                },
                {
                    columns: [
                        {
                            component: dialogueMessage && <div className='value-text-new margin-top-10'>{dialogueMessage}</div>,
                            gridSize: 12,
                        },
                    ],
                }
            );
        }
        else if(radioValue === "cancel-de-reg"){
            layout.push(
            {
                columns: [
                {
                    component: (
                    <LabelValueDisplay
                        label="Organization"
                        value={row['dpName']}
                    />
                    ),
                    gridSize: 12,
                },
                ],
            },
            {
                columns: [
                {
                    component: (
                    <LabelValueDisplay
                        label="Device"
                        value={row['deviceAliasName'] ?? row['deviceId']}
                    />
                    ),
                    gridSize: 12,
                },
                ],
            },
            {
                columns: [
                {
                    component: <div className='rem-conn-all'><LabelValueDisplay label='' value={'Please provide a reason to cancel the de-registration.'} /></div>,
                    gridSize: 12,
                },
                ],
            },
            {
                columns: [
                {
                    component:
                    (
                        <LabelValueDisplay
                        label="Reason"
                        isInput
                        placeholder="Enter Reason"
                        value={cancelDeRegReason}
                        onChange={(e) => {
                            const value = e.target.value;
                            setCancelDeRegReason(value);
                            if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
                            setReasonError("Only letters, numbers, and spaces are allowed");
                            } else if (value.trim() === "") {
                            setReasonError("Reason is required");
                            } else {
                            setReasonError("");
                            }
                        }}
                        error={reasonError}
                        />
                    ),
                    gridSize: 12,
                },
                ],
            }
            );
        }
        return layout;
    }

    const cancelDeRegisterWarning = () => {
        return <div className='value-text'>
        You are about to cancel the DeRegistration ?
        </div>
    }

    const getWarningInfo = (option) => {
        switch (option) {
        case 'cancel-de-reg':
            return cancelDeRegisterWarning();
        default:
            return null;
        }
    };

    useEffect(() => {
        if (_.isEmpty(trackInventoryStatusData)) return;
        const status = trackInventoryStatusData?.status;
        if (status == 'DONE' || status == 'FAILED' || status == 'NOT_STARTED') {
            setSyncInprogress(false);
            return;
        }
        if (status == 'IN_PROGRESS') {
            setSyncInprogress(true);
            return;
        }
    }, [trackInventoryStatusData]);


    const handleSaveDisabled = () => {
        switch (radioValue) {
            case 'transfer_license':
                return !selectedDevice;
        case 'cancel-de-reg':
            return !!reasonError || !cancelDeRegReason.trim();
        default:
            return false;
        }
    };

    const isTodayOrFuture = (dateStr: string) => {
        if (!dateStr) return false;
    
        const date = moment(dateStr, "YYYY-MM-DD HH:mm:ss").startOf("day");
        const today = moment().startOf("day");
    
        return date.isSameOrAfter(today);
    };

    const handleResetValues = () => {
        setRadioValue('');
        setSelectedOption('');
        setSelectedDevice('');
        setDialogueMessage('');
        setCancelDeRegReason('');
        setReasonError('');
        setWarningModal(false);
        setOpenPopup(false);
    };

    return <div style={{ marginRight: '10px' }}>
        <Grid container spacing={2} mt={1} display={'flex'} alignItems='center'>
            <Grid item xs={3}>
                <LabelValueDisplay
                    label="License"
                    value={`${row['tierAlias']}`}
                    paddingLeft={10}
                />
            </Grid>
            <Grid item xs={4}>
                <LabelValueDisplay
                    label="Term"
                    value={row?.['termDisplay']}
                />
            </Grid>
            <Grid item xs={1.8} sm={1.5} md={1.5} lg={1.5}>
                <LabelValueDisplay
                label="Term Ends"
                value={row?.['termValue'] == -1 ? "Not Applicable" : formatToReadable(row?.license_expiry_date)}
                />
            </Grid>
            <Grid item xs={3}>
                <AddButton
                    onAddClick={() => {
                        setSelectedOption('change');
                        setOpenPopup(true);
                    }}
                    addLabel='Change'
                    icon={change_license_icon}
                    disabled={!(isAllowed?.isTransferAllowed && row?.['licenseType'] == 'Production' && row?.expiryDate && moment(row?.expiryDate).startOf("day").isSameOrAfter(moment().startOf("day")))}
                />
            </Grid>
        </Grid>
        {row['deRegisteredDate'] && isTodayOrFuture(row['deRegisteredDate']) && <>
            <SingleLineDisplay top={4} bottom={25} />
            <Grid container display={'flex'} alignItems={'center'}>
            <Grid item xs={8.5} sm={8.5} md={8.5} lg={8.5}>
                <LabelValueDisplay
                label="DeRegistration Date"
                value={`${row['deRegisteredDate']?? ''}`}
                paddingLeft={10}
                />
            </Grid>
            <Grid item xs={3.5} sm={3.5} md={3.5} lg={3.5} display={'flex'} gap={'10px'}>
                <AddButton onAddClick={() => { setSelectedOption('cancel-de-reg'); setOpenPopup(true); }} 
                    addLabel={syncInprogress ? 'In Progress' : 'Cancel DeRegistration'} 
                    disabled={syncInprogress} 
                />
            </Grid>
            </Grid>
        </>}
        <AddEditInterfaceModal
            open={openPopup}
            onClose={() => { setOpenPopup(false); handleResetValues(); }}
            onSave={() => {
                if (radioValue === 'transfer_license') {
                    handleConfirm();
                } else if(radioValue === "cancel-de-reg"){
                    setWarningModal(true);
                    setOpenPopup(false);
                }}
            }
            saveText={radioValue == 'transfer_license' ? 'Transfer' : radioValue === "cancel-de-reg" ? "Cancel DeRegistration"  : 'Confirm'}
            disableSave={handleSaveDisabled()}
            title={radioValue == 'transfer_license' ? 'Transfer License' : radioValue === "cancel-de-reg" ? "Cancel DeRegistration" : ''}
            layout={getLayout()}
        />

        <InfoModal
            open={warningModal}
            onClose={() => { setWarningModal(false); handleResetValues() }}
            onConfirm={handleConfirm}
            saveText={'Confirm & Move'}
            warningInfo={getWarningInfo(radioValue)}
        />

        {setWHProdGPDeviceListLoading || setTransferLicenseLoading || setDpInfoLoading ? (
            <CustomLoader
                showLoader={true}
                loadingText={"Please wait..."}
            />
        ) : null}
    </div>
}

const mapStateToProps = (state) => ({
    getWHProdGPDeviceList: state.authReducer.getWHProdGPDeviceList,
    setWHProdGPDeviceListLoading: state.authReducer.setWHProdGPDeviceListLoading,
    getTransferLicense: state.authReducer.getTransferLicense,
    setTransferLicenseLoading: state.authReducer.setTransferLicenseLoading,
    getDpInfo: state.authReducer.getDpInfo,
    setDpInfoLoading: state.authReducer.setDpInfoLoading,
    selectedOu: state.authReducer.selectedOu,
    trackInventoryStatusData: state.authReducer.trackInventoryStatusData,
});

export default withRouter(
    connect(mapStateToProps, { getWHProdGPDeviceListData, getTransferLicenseData, getOrganisationInfo, getInventoryWarehouseTableData, getCancelDeRegisterData  })(Association)
);